const SUPPORTED_PLATFORMS = {
    IOS: "ios",
    ANDROID: "android",
    WEB: "web",
}

const IDENTITY = {
    INIT: "synapse:init",
    CONFIG: "synapse:config",
    LEGACY: "synapse:legacy",
    PLATFORM: "synapse:platform",
}

const DEFAULT_COOKIE_CONFIG = {
    secure: true,
}

const DEFAULT_VERSION = "*"

const DEFAULT_PLATFORM = SUPPORTED_PLATFORMS.WEB

const DEFAULT_SUPPORT_VERSIONS = {
    android: DEFAULT_VERSION,
    ios: DEFAULT_VERSION,
}

const LEGACY_FALLBACK = false

module.exports = {
    IDENTITY,
    DEFAULT_COOKIE_CONFIG,
    SUPPORTED_PLATFORMS,
    DEFAULT_VERSION,
    DEFAULT_PLATFORM,
    DEFAULT_SUPPORT_VERSIONS,
    LEGACY_FALLBACK,
}
